// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"00864a47","239":"ad40150f","455":"6939739a","488":"badd9f8b"}[chunkId] + ".chunk.js";
};